<template>
	<Modal
		class="parallel-view-modal"
		:title="title"
		:closeable="false"
		:blocking="true"
	>
		<!-- body -->
		<template #body>
			<p>
				{{ $I18n.trans('view_mode.parallel_views.message') }}
			</p>
			<div
				class="parallel-view-modal__device"
			>
				<strong>{{ deviceLabel }}</strong>
			</div>
			<p class="parallel-view-modal__hint">
				{{ $I18n.trans('view_mode.parallel_views.hint') }}
			</p>
			<p
				v-if="error"
				class="parallel-view-modal__error"
				role="alert"
			>
				{{ error }}
			</p>
		</template>
		<!-- footer -->
		<template #footer-buttons>
			<button
				type="button"
				class="button button--secondary"
				:disabled="isResuming"
				@click="reload"
			>
				{{ $I18n.trans('view_mode.parallel_views.retry') }}
			</button>
			<button
				type="button"
				class="button button--primary"
				:disabled="isResuming"
				@click="resumeHere"
			>
				{{ resumeLabel }}
			</button>
		</template>
	</Modal>
</template>

<script>
import UAParser from 'ua-parser-js';
import api from '@videotools/js/api/client';
import storage from '@shared/js/storage';
import Modal from '../modal';

export default {
	name:       'ParallelViewModal',
	components: { Modal },
	props:      {
		parallelView: {
			type:    Object,
			default: () => null,
		},
		eventId: {
			type:     Number,
			required: true,
		},
	},
	data() {
		return {
			title:      this.$I18n.trans('view_mode.parallel_views.title'),
			isResuming: false,
			error:      null,
		};
	},
	computed: {
		deviceLabel() {
			const userAgent = this.parallelView?.userAgent || '';
			if (!userAgent) {
				return this.$I18n.trans('view_mode.parallel_views.unknown_device');
			}
			if (userAgent.includes('Swisscom') || userAgent.includes('BlueTv')) {
				return 'Blue TV';
			}

			const parsed = new UAParser(userAgent).getResult();
			return [parsed.browser.name, parsed.os.name].filter(Boolean).join(' · ') || this.$I18n.trans('view_mode.parallel_views.unknown_device');
		},
		resumeLabel() {
			return this.$I18n.trans(`view_mode.parallel_views.${this.isResuming ? 'resuming' : 'resume'}`);
		},
	},
	methods: {
		reload() {
			window.location.reload();
		},
		async resumeHere() {
			this.isResuming = true;
			this.error = null;
			try {
				await api.resumeParallelView(this.eventId, storage.viewerId);
				this.reload();
			} catch {
				this.isResuming = false;
				this.error = this.$I18n.trans('view_mode.parallel_views.resume_error');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.parallel-view-modal__device {
	margin: 24px 0;
	border: 1px solid var(--color-grey-750);
	background-color: var(--color-grey-950);
	padding: 16px;
}

.parallel-view-modal__hint {
	margin-bottom: $sp4;
}

.parallel-view-modal__error {
	color: var(--color-red);
}
</style>
